export default __webpack_public_path__ + "images/0202989a63fcaef1ef5f1dc39ef66365.png";